<template>
    <div class="auth-wrapper middle-aligner">
        <div class="inner">
            <base-logo class="main-logo"></base-logo>
            <div class="card card-auth with-shadow">
                <h2 class="auth-heading">
                    Contact Us
                    <span>
                        If you're having trouble logging in or with your
                        password.
                    </span>
                </h2>
                <div class="auth-body">
                    <b-form @submit.stop.prevent="onSubmit">
                        <b-form-group
                            id="contact_email_address"
                            label="EMAIL ADDRESS"
                            label-for="contact-email-input"
                        >
                            <b-form-input
                                id="contact-email-input"
                                v-model="formData.email"
                                v-validate="{ required: true, email: true }"
                                placeholder="Enter your email address"
                                data-vv-name="email"
                                :class="{
                                    'is-invalid': errors.has('email'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group
                            id="contact_description"
                            label="Description of the issue"
                            label-for="contact-description-input"
                        >
                            <b-form-textarea
                                id="contact-description-input"
                                v-model="formData.description"
                                v-validate="{ required: true, max: 500 }"
                                rows="3"
                                placeholder="Please provide a detailed description of this issue"
                                data-vv-name="description"
                                :class="{
                                    'is-invalid': errors.has('description'),
                                }"
                            ></b-form-textarea>
                        </b-form-group>
                        <base-button
                            btn-label="SEND"
                            btn-type="submit"
                            btn-variant="primary"
                            :class="loading ? 'disabled' : ''"
                        ></base-button>
                        <base-toast></base-toast>
                    </b-form>
                </div>
            </div>
            <div class="contact-link text-center">
                Existing system user?
                <router-link to="/"> Sign In</router-link>
            </div>
        </div>
        <base-footer></base-footer>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {},
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            disableClass: false,
            formData: this.initializeFormData(),
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: { ...mapGetters(['loading']) },

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        initializeFormData() {
            return {
                email: '',
                description: '',
            }
        }, // End of initializeFormData() method

        async onSubmit() {
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                    if (result) {
                        await this.$store.dispatch(
                            'contactUsForm',
                            this.formData
                        )
                        this.clearFormData()
                    }
                } catch (error) {
                    console.log(error)
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method

        clearFormData() {
            this.$validator.reset()
            Object.assign(this.formData, this.initializeFormData())
        }, // End of clearFormData() method
    }, // End of Component > methods

    // you can pass a single action as below
    action: {
        text: 'Cancel',
        onClick: (e, toastObject) => {
            toastObject.goAway(0)
        },
    }, // End of Component > mounted
} // End of export default
</script>
